import { useEffect, useState, useCallback } from 'react';
import { onToast, ToastItem } from './toastManager';

const TOAST_DURATION = 4000; // ms before auto-dismiss

const TYPE_STYLES: Record<ToastItem['type'], { bg: string; border: string; icon: string; text: string }> = {
  success: { bg: '#ecfdf5', border: '#86efac', icon: '\u2713', text: '#166534' },
  error:   { bg: '#fef2f2', border: '#fca5a5', icon: '\u2717', text: '#991b1b' },
  warning: { bg: '#fffbeb', border: '#fcd34d', icon: '\u26A0', text: '#92400e' },
  info:    { bg: '#eff6ff', border: '#93c5fd', icon: '\u2139', text: '#1e40af' },
};

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const unsub = onToast((toast) => {
      setToasts((prev) => [...prev, toast]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, TOAST_DURATION);
    });
    return unsub;
  }, []);

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        maxWidth: 400,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((t) => {
        const s = TYPE_STYLES[t.type];
        return (
          <div
            key={t.id}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              padding: '12px 16px',
              background: s.bg,
              border: `1px solid ${s.border}`,
              borderRadius: 8,
              boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
              pointerEvents: 'auto',
              animation: 'slideInRight 0.25s ease-out',
              fontFamily: 'inherit',
            }}
          >
            <span
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: s.text,
                lineHeight: '20px',
                flexShrink: 0,
              }}
            >
              {s.icon}
            </span>
            <span
              style={{
                fontSize: 13,
                color: s.text,
                lineHeight: '20px',
                flex: 1,
                wordBreak: 'break-word',
              }}
            >
              {t.message}
            </span>
            <button
              onClick={() => dismiss(t.id)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: s.text,
                opacity: 0.5,
                fontSize: 14,
                lineHeight: '20px',
                padding: 0,
                flexShrink: 0,
              }}
            >
              {'\u2715'}
            </button>
          </div>
        );
      })}
    </div>
  );
}
